module.exports = __webpack_public_path__ + "static/media/bg-mletter.b1b7812f.svg";